import React, { createContext, useContext } from "react";
import { useConversationExporter } from "../hooks/useConversationExporter";

type ConversationExporterContextType = ReturnType<typeof useConversationExporter>;

const ConversationExporterContext = createContext<ConversationExporterContextType | undefined>(undefined);

interface ConversationExporterProviderProps {
  children: React.ReactNode;
}

export const ConversationExporterProvider: React.FC<ConversationExporterProviderProps> = ({ children }) => {
  const conversationExporterState = useConversationExporter();

  return <ConversationExporterContext.Provider value={conversationExporterState}>{children}</ConversationExporterContext.Provider>;
};

export const useConversationExporterContext = (): ConversationExporterContextType => {
  const context = useContext(ConversationExporterContext);
  if (context === undefined) {
    throw new Error("useConversationExporterContext must be used within a ConversationExporterProvider");
  }
  return context;
};

/** Non-throwing read, for components that can also receive explicit state. */
export const useConversationExporterContextSafe = (): ConversationExporterContextType | undefined => useContext(ConversationExporterContext);

/** The exporter's presentation contract: context value or an injected one. */
export type ConversationExporterState = ConversationExporterContextType;
